import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import styled from '@emotion/styled';
import { getCurrentMonth, getLastMonth, formatMonthKey } from '../utils/dateUtils';
import HoursByTypeTable from './HoursByTypeTable';

const MonthToggleGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

const TableArea = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
}));

const EmptyState = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    padding: theme.spacing(3, 0),
    textAlign: 'center',
}));

const AccountHoursByGroupDialog = ({ open, onClose, groupsTime, month, onMonthChange }) => {
    const currentMonth = getCurrentMonth();
    const lastMonth = getLastMonth();

    const rows = (groupsTime || [])
        .map((group) => ({
            key: group._id ? group._id.toString() : 'ungrouped',
            label: group.name,
            time: group.aggregatedTime?.monthly?.[month] || {},
        }))
        .map((row) => ({ ...row, minutes: Object.values(row.time).reduce((sum, value) => sum + value, 0) }))
        .filter((row) => row.minutes > 0)
        .sort((a, b) => b.minutes - a.minutes);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Hours by group — {formatMonthKey(month)}</DialogTitle>
            <DialogContent>
                <MonthToggleGroup
                    exclusive
                    size="small"
                    color="primary"
                    aria-label="Which month to show hours for"
                    value={month}
                    onChange={(event, value) => value && onMonthChange(value)}
                >
                    <ToggleButton value={lastMonth}>{formatMonthKey(lastMonth)}</ToggleButton>
                    <ToggleButton value={currentMonth}>{formatMonthKey(currentMonth)}</ToggleButton>
                </MonthToggleGroup>
                <TableArea>
                    {rows.length === 0 ? (
                        <EmptyState variant="body2">No time was logged on this account in {formatMonthKey(month)}.</EmptyState>
                    ) : (
                        <HoursByTypeTable rows={rows} labelHeading="Group" hideEmptyColumns />
                    )}
                </TableArea>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AccountHoursByGroupDialog;
